import React, { useRef, useEffect } from "react";
import { useLockersContext } from "../contexts/LockersContext";
import { useSpecificLockerActionContext } from "../contexts/SpecificLockerActionContext";
import { useTrackingContext } from "../contexts/TrackingContext";
import { ActionType, TrackedAction } from "../data/Tracking";
import { getCorrelationId, trackApplicationClosed, trackApplicationLoad, trackLockerFavourite, trackLockerSelected } from "../services/trackingService";

const TrackingComponent = () => {
    const {
        selectedLocker
    } = useSpecificLockerActionContext();

    const {
        domain,
        isSelectLockerClicked,
        setIsSelectLockerClicked,
        favouriteLockerActioned,
        correlationId,
        userFingerprint
    } = useTrackingContext();

    const {
        lockerPluginOptions
    } = useLockersContext();


    const trackedDomainRef = useRef("");
    const trackedUserFingerprintRef : React.MutableRefObject<string | undefined> = useRef(undefined);

    useEffect(() => {
        const trackingParam: TrackedAction = {
            domain: domain,
            integratorId: lockerPluginOptions.clientId,
            correlationId: getCorrelationId(correlationId),
            userFingerprint: userFingerprint,
            apiUsername: lockerPluginOptions.apiUsername,
            type: ActionType.ApplicationLoad
        }
        trackApplicationLoad(trackingParam);
        trackedDomainRef.current = domain;
    }, [domain]);

    useEffect(() => {
        trackedUserFingerprintRef.current = userFingerprint;
    }, [userFingerprint]);

    useEffect(() => {
        if (isSelectLockerClicked) {
            setIsSelectLockerClicked(false);
            const trackingParam: TrackedAction = {
                domain: domain,
                integratorId: lockerPluginOptions.clientId,
                lockerId: selectedLocker.lockerId,
                correlationId: getCorrelationId(correlationId),
                userFingerprint: userFingerprint,
                cityId: selectedLocker.cityId,
                countryId: selectedLocker.countryId,
                countyId: selectedLocker.countyId,
                apiUsername: lockerPluginOptions.apiUsername,
                type: ActionType.LockerSelected
            }
            trackLockerSelected(trackingParam);
        }
    }, [isSelectLockerClicked]);

    useEffect(() => {
        if (favouriteLockerActioned.isFavouriteLocker) {
            const trackingParam: TrackedAction = {
                domain: domain,
                integratorId: lockerPluginOptions.clientId,
                lockerId: selectedLocker.lockerId,
                correlationId: getCorrelationId(correlationId),
                favouriteLockerType: favouriteLockerActioned.favouriteLockerType,
                userFingerprint: userFingerprint,
                cityId: selectedLocker.cityId,
                countryId: selectedLocker.countryId,
                countyId: selectedLocker.countyId,
                apiUsername: lockerPluginOptions.apiUsername,
                type: ActionType.LockerFavourite
            }

            trackLockerFavourite(trackingParam);
        }
    }, [favouriteLockerActioned]);

    useEffect(() => {
        subscribeToOpenCloseModal();
    }, []);

    const subscribeToOpenCloseModal = (): void => {
        window.addEventListener("message", (event) => {
            try {
                if (event.data === "ModalClosed") {
                    if (trackedDomainRef.current !== "") {
                        const trackingParam: TrackedAction = {
                            domain: trackedDomainRef.current,
                            integratorId: lockerPluginOptions.clientId,
                            correlationId: getCorrelationId(correlationId),
                            userFingerprint: trackedUserFingerprintRef.current,
                            apiUsername: lockerPluginOptions.apiUsername,
                            type: ActionType.ApplicationClosed
                        }
                        trackApplicationClosed(trackingParam);
                    }
                }
                if (event.data === "ModalOpen") {
                    if (trackedDomainRef.current !== "") {
                        const trackingParam: TrackedAction = {
                            domain: trackedDomainRef.current,
                            integratorId: lockerPluginOptions.clientId,
                            correlationId: getCorrelationId(correlationId),
                            userFingerprint: trackedUserFingerprintRef.current,
                            apiUsername: lockerPluginOptions.apiUsername,
                            type: ActionType.ApplicationLoad
                        }
                        trackApplicationLoad(trackingParam);
                    }
                }
            }
            catch { }
        });
    }

    return (
        <>
        </>
    )
}

export default TrackingComponent;